<!-- 组织机构管理-->

<template>
  <div class="c-profile-content">
    <ul class="c-profile-lsit c-experts-lsit" v-for="(item,index) in list" :key="index">
      <li class="c-profile-lsit-li">
        <div class="c-profile-center-box">
          <h3>{{item.category}} </h3>
          <div class="c-btn-box">
            <a href="javascrip:;">{{item.grade}}</a>
            <a href="javascrip:;">{{item.edubg}}</a>
          </div>
          <p>{{`需求描述:${item.content}`}}</p>
        </div>
        <div class="c-experts-right-box">
          <a href="javascrip:;" @click.stop="queryApplylist(item,index)">查看</a>
          <p><img class="c-time-icon" src="../../assets/main/shijian@2x.png">{{item.createtime}}</p>
        </div>
      </li>
      <div class="speciallist-apply-list" v-show="`mine${index}`==isshowList">
        <table cellpadding="0" cellspacing="0">
          <tr>
            <th>专家名</th>
            <th>专家联系方式</th>
            <th>专家详情</th>
          </tr>
          <tr v-for="(app,index) in applylist" :key="'tb'+index">
            <td>{{app.name}}</td>
            <td>{{app.mobile}}</td>
            <td><a href="javascript:;" @click.stop="spDetail(app)">查看</a></td>
          </tr>
        </table>
      </div>
    </ul>
  </div>
</template>

<script>
  import {
    getMySpeciallistAskForList,
    specialistaskforanswerlist
  } from '@/api/specialist.js'
  export default {
    name: 'EngageSpecialist',
    props: {},
    components: {},
    data() {
      return {
        list: [],
        page: 1,
        limit: 10,
        applylist: [],
        isshowList: ''
      }
    },
    computed: {},
    mounted() {
      this.queryList()
    },
    methods: {
      queryList() {
        const page = this.page
        const limit = this.limit
        this.$http.get(getMySpeciallistAskForList(), {
          page,
          limit
        }).then((res) => {
          console.log(res);
          if (res.code === 1) {
            this.list = res.data.list
          }
        });
      },
      queryApplylist(sp,index) {
        if (this.isshowList === `mine${index}`) {
          this.isshowList = ''
          this.applylist = []
          return
        }
        this.isshowList = `mine${index}`
        const aid = sp.aid
        this.$http.get(specialistaskforanswerlist(), {
          aid
        }).then((res) => {
          console.log(res);
          if (res.code === 1) {
            this.applylist = res.data
          }
        });
      },
      spDetail(sp) {
        this.$router.push('/specialist-detail?sid=' + sp.sid)
      }
    }
  };
</script>

<style>
  @import url(./publishproject.css);

  .c-standard-right-box {
    float: right;
  }

  .c-standard-right-box p {
    color: #333;
    font-size: 14px;
    width: 136px;
    text-align: center;
    margin-top: 20px;
    clear: both;
    display: block;
    padding-top: 30px;
  }

  .c-standard-right-box p.p1 {
    font-size: 14px;
    color: #666;
    margin-top: 5px;
  }

  .c-standard-right-box p.c-txt-col {
    color: #267FF2;
    margin-top: 0;
    padding-top: 10px;
    font-size: 20px;
  }

  .c-standard-right-box a {
    /* float: right; */
    background: #267FF2;
    line-height: 30px;
    color: #fff;
    /* padding: 0 5px; */
    font-size: 12px;
    display: block;
    margin-top: 10px;
    text-align: center;
  }

  .speciallist-apply-list th {
    line-height: 48px;
    background: #F0F0F0;
    font-size: 16px;
    color: #666;
  }

  .speciallist-apply-list th a {
    display: block;
    width: 97px;
    height: 28px;
    line-height: 28px;
    border: 1px solid #267FF2;
    ;
    text-align: center;
    font-size: 16px;
    font-weight: normal;
    margin: 0 auto;
    color: #267FF2;
  }

  .speciallist-apply-list table {
    width: 100%;
    border: 1px solid #F0F0F0;
  }

  .speciallist-apply-list td {
    border-bottom: 1px solid #F0F0F0;
    height: 48px;
    text-align: center;
    color: #666;
  }

  .speciallist-apply-list td a {
    /* float: left; */
    color: #267FF2;
    /* padding-left: 20px; */
    text-align: center;
  }

  .speciallist-apply-list td span {
    float: center;
    color: #267FF2;
    cursor: pointer;
    text-align: center;
  }


  @media screen and (max-width: 850px) {
    .c-standard-right-box p {
      position: absolute;
      right: 0;
      padding-top: .1rem;
      top: 0;
    }

    .c-standard-right-box a {
      position: absolute;
      right: 0;
      padding: 0 .3rem;
      line-height: .56rem;
      margin-top: 0;
      font-size: .24rem;
      bottom: .3rem;
    }

    .c-standard-right-box p.p1 {
      font-size: .28rem;
      margin-top: 0.6rem;
    }

    .c-standard-right-box p.c-txt-col {
      margin-top: 1.1rem;
      font-size: .36rem;
    }

    .c-standard-right-box p {
      top: .2rem;
    }

    .institutions-standard-box {
      width: 100%;
      margin-left: 0;
    }

    .tab-box {
      height: .8rem;
      line-height: .8rem;
    }

    .tab-box a {
      width: 1.84rem;
      font-size: .32rem;
    }



    .speciallist-apply-list th {
      height: .6rem;
      font-size: .24rem;
      font-weight: normal;
    }

    .speciallist-apply-list td {
      height: .6rem;
      line-height: .6rem;
      font-size: .22rem;
    }

    .speciallist-apply-list td a {
      width: 100%;
      text-align: center;
      margin-left: 0;
      box-sizing: border-box;
      padding-left: 0;
      line-height: .5rem;
      height: .5rem;
    }

    .speciallist-apply-list .ctl-btn {
      width: 1.2rem;
      line-height: 0.4rem;
      float: right;
      color: #F0F0F0;
      margin-right: 0.02rem;
      background: #267FF2;
      text-align: center;
    }
  }
</style>
